'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import uniqid from 'uniqid';
import numeral from 'numeral';
import TextInput from 'Components/Forms/Elements/TextInput';
import Select from 'Components/Forms/Elements/Select';
import Layout from 'Layouts/Back';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import bemit from 'Functions/bemit';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import { action } from 'Shared/Routes';
import { safeNumeral } from 'Shared/utilities';
let app = window.app;
export default class PackOrderForm extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPack();
    component.fetchCompanies();
  }
  fetchPack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/pack/get-all', {
      display_status: "true",
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        packs: response.data,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchCompanies = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllCompanies'), {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        companies: response.data,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  addQuantity = pack_id => {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    const value = numeral(safeNumeral(state['packorder[' + pack_id + '][quantity]'])).add(1).format('0');
    component.setState({
      ['packorder[' + pack_id + '][quantity]']: value
    });
  };
  removeQuantity = pack_id => {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    const value = numeral(safeNumeral(state['packorder[' + pack_id + '][quantity]'])).subtract(1).format('0');
    component.setState({
      ['packorder[' + pack_id + '][quantity]']: value
    });
  };
  paymentByOrderForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const packorder = getFormData({
      state: state,
      pattern: 'packorder['
    });
    qwest.post('/packorder/payment-by-order-form', packorder).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo('/liste-des-commandes');
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  paymentByCard = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const packorder = getFormData({
      state: state,
      pattern: 'packorder['
    });
    qwest.post('/packorder/payment-by-card', packorder).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        packorder: response.packorder,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handlePaymentFail = ({
    error,
    error_type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      packorder: undefined,
      error: error
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    let companies_options = (state.companies || []).map(function (company) {
      let option = {
        value: company.id,
        label: company.name
      };
      return option;
    });
    let packs_row = (state.packs || []).map(function (pack) {
      let amount = numeral(state['packorder[' + pack.id + '][quantity]'] || 0).multiply(pack.credit_amount).multiply(pack.amount).format('0.00');
      let output = /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__row",
        key: pack.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.title), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-side-widget__element people"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-side-widget__container"
      }, /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-btn', ['less']) + ' u-margin-right-10',
        onClick: e => component.removeQuantity(pack.id)
      }, "- 1"), /*#__PURE__*/React.createElement(TextInput, {
        className: "c-side-widget__input u-full-width",
        name: 'packorder[' + pack.id + '][quantity]',
        onChange: component.handleChange,
        value: state['packorder[' + pack.id + '][quantity]'],
        id: state.people_id,
        status: state.status_messages,
        "safe-value": true,
        int: true,
        inputMode: "numeric",
        min: "1"
      }), /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-btn', ['more']) + ' u-margin-left-10',
        onClick: e => component.addQuantity(pack.id)
      }, "+ 1")))), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.credit_amount), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.amount, "\u20AC"), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, amount, "\u20AC"), /*#__PURE__*/React.createElement("div", {
        className: "c-dashboard__cell"
      }, pack.duration, " j"));
      return output;
    });
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Nouvelle commande"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-full-width u-margin-bottom-10"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(Select, {
      options: companies_options,
      onChange: component.handleChange,
      value: state['packorder[company_id]'],
      name: "packorder[company_id]",
      type: "text",
      label: "Entreprise",
      key: uniqid(),
      status: state.status_messages
    })))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-dashboard', ['head'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Pack"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Quantit\xE9"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Nombre de cr\xE9dit"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Prix du cr\xE9dit \xE0 l'heure HT"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Tarif HT"), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell"
    }, "Dur\xE9e de consommation"))), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-dashboard')
    }, packs_row)))), /*#__PURE__*/React.createElement("div", {
      className: "u-text-center"
    }, status, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.paymentByOrderForm
    }, "Valider la commande")));
    return output;
  }
}
